import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Hourglass, Loader2, Play } from "lucide-react";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });

export const PendingFlows = ({ projectId, flows = [], canStart, onStarted }) => {
  const [busy, setBusy] = useState(null);
  if (!flows.length) return null;
  const start = async (pf) => {
    setBusy(pf.id);
    try { const { data } = await api.post(`/console/projects/${projectId}/pending-flows/${pf.id}/start`); toast.success(`“${pf.flow_name}” started · ${data.created} tasks`); onStarted(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); onStarted(); } finally { setBusy(null); }
  };
  return (
    <div className="mb-5 grid gap-2 md:grid-cols-2" data-testid="pending-flows">
      {flows.map((pf) => (
        <div key={pf.id} data-testid={`pending-flow-${pf.id}`} className="flex items-center gap-3 rounded-2xl border border-dashed border-[#d9cffd] bg-[#FAF8FF] px-4 py-3">
          <span className="h-9 w-9 rounded-xl bg-[#EDE7FF] text-[#723FFF] flex items-center justify-center shrink-0"><Hourglass className="h-4 w-4" /></span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-[#06060C] truncate">Waiting · {pf.flow_name}</p>
            <p className="text-[11px] text-[#9FA1A4] truncate" title={(pf.wait_titles || []).join(", ")}>
              {pf.mode === "date" ? `Starts ${fmt(pf.start_date)}` : pf.mode === "flow" ? `Starts when ${(pf.wait_titles || []).map((t) => `“${t}”`).join(", ")} ${(pf.wait_titles || []).length > 1 ? "flows are" : "flow is"} done` : `Starts when ${(pf.wait_titles || []).map((t) => `“${t}”`).join(", ")} ${(pf.wait_titles || []).length > 1 ? "are" : "is"} done`}
            </p>
          </div>
          {canStart && <Button data-testid={`pending-flow-start-${pf.id}`} size="sm" disabled={busy === pf.id} onClick={() => start(pf)} className="bg-[#06060C] text-white hover:bg-[#1c1c24] rounded-full h-8 text-xs shrink-0">{busy === pf.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><Play className="h-3 w-3 mr-1" /> Start now</>}</Button>}
        </div>
      ))}
    </div>
  );
};
